import ProjectDetails from "./ProjectDetails";
import { useState } from "react";
import { currencyFormate, formate } from "./utiil/Formate";


const Project = ({project}) => {
    const [showDetails, setShowDetails] = useState(false)

    const handleShowDetails = async () => {
        setShowDetails(!showDetails);
    }

    return (
        <li className="project-item">
            <div className="project-item-header">
                <span className="project-code">{project.code}</span>
            </div>
            <div className="project-item-body" onClick={handleShowDetails}>
                <span className="project-client">{project.client.name}</span>
                <span className="project-name">{project.name}</span>
                <div className="project-item-stats">
                    <span className="project-stat">{formate(project.sum_hours)} t</span>
                    <span className="project-stat">{currencyFormate(project.sum_amount)} kr</span>
                </div>
            </div>
            <ProjectDetails show={showDetails} onClose={handleShowDetails} project={project} />
        </li>
    )
}
export default Project;